(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drzzl-cook-hub"] && !Shopify.designMode) return;
  try {
    
function initCookHub(root=document){
 root.querySelectorAll('[data-cook-newsletter]').forEach(form=>{
 if(form.dataset.cookReady)return;form.dataset.cookReady='true';
 const tags=form.querySelector('[data-cook-tags]');
 const update=()=>{if(tags)tags.value=['newsletter','cook-properly',...[...form.querySelectorAll('[data-cook-preference]:checked')].map(input=>input.value)].join(',');};
 form.addEventListener('change',update);form.addEventListener('submit',update);update();
 });
 root.querySelectorAll('.cook-hub').forEach(hub=>{
 if(hub.dataset.ready)return;hub.dataset.ready='true';
 const search=hub.querySelector('[data-hub-search]'),buttons=[...hub.querySelectorAll('[data-hub-filter]')],items=[...hub.querySelectorAll('[data-hub-item]')];let category=new URLSearchParams(location.search).get('category')||'all';if(!['all','recipes','guides','people'].includes(category))category='all';buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hubFilter===category)));
 const update=()=>{const query=search.value.toLocaleLowerCase().trim();let count=0;items.forEach(item=>{const match=(category==='all'||item.dataset.category===category)&&(!query||item.dataset.search.toLocaleLowerCase().includes(query));item.hidden=!match;if(match)count++;});hub.querySelector('[data-hub-count]').textContent=count+' '+(count===1?'story':'stories');hub.querySelector('[data-hub-empty]').hidden=count>0;};
 buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.hubFilter;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));update();}));search.addEventListener('input',update);update();
});}initCookHub();document.addEventListener('shopify:section:load',e=>initCookHub(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drzzl-wholesale-v2"] && !Shopify.designMode) return;
  try {
    
function initDrzzlWholesale(root=document){
 root.querySelectorAll('.drzzl-trade').forEach(section=>{
  if(section.dataset.locatorReady)return;
  section.dataset.locatorReady='true';
  const map=section.querySelector('.drzzl-trade__map');
  const status=section.querySelector('.drzzl-trade__map-status');
  const show=location=>{map.src='https://www.google.com/maps?q='+encodeURIComponent(location)+'&output=embed';status.textContent=location;};
  section.querySelectorAll('[data-location]').forEach(button=>button.addEventListener('click',()=>show(button.dataset.location)));
  const stores=[...section.querySelectorAll('.drzzl-trade__stores li')];
  const cache=new Map();
  const locate=async postcode=>{
   if(cache.has(postcode))return cache.get(postcode);
   const response=await fetch('https://api.postcodes.io/postcodes/'+encodeURIComponent(postcode),{signal:AbortSignal.timeout(8000)});
   if(!response.ok)throw new Error('postcode');
   const data=(await response.json()).result;
   cache.set(postcode,data);
   return data;
  };
  const distance=(a,b)=>{
   const r=Math.PI/180;
   const dLat=(b.latitude-a.latitude)*r,dLon=(b.longitude-a.longitude)*r;
   const n=Math.sin(dLat/2)**2+Math.cos(a.latitude*r)*Math.cos(b.latitude*r)*Math.sin(dLon/2)**2;
   return 3958.8*2*Math.atan2(Math.sqrt(n),Math.sqrt(1-n));
  };
  section.querySelector('.drzzl-trade__search')?.addEventListener('submit',async event=>{
   event.preventDefault();
   const form=event.currentTarget,button=form.querySelector('button');
   const value=new FormData(form).get('location').trim();
   stores.forEach(store=>{store.hidden=false;store.querySelector('.drzzl-trade__distance').textContent='';});
   if(!value)return;
   const matches=stores.filter(store=>store.textContent.toLowerCase().includes(value.toLowerCase()));
   if(matches.length){
    stores.forEach(store=>store.hidden=!matches.includes(store));
    show(matches[0].querySelector('[data-location]').dataset.location);
    return;
   }
   if(!/^[a-z]{1,2}[0-9][a-z0-9]?\s*[0-9][a-z]{2}$/i.test(value)){
    status.textContent=section.dataset.noResults;
    return;
   }
   button.disabled=true;status.textContent=section.dataset.searching;
   try{
    const origin=await locate(value);
    const results=await Promise.all(stores.map(async store=>({store,miles:distance(origin,await locate(store.dataset.postcode))})));
    results.sort((a,b)=>a.miles-b.miles);
    results.forEach(result=>{
     result.store.querySelector('.drzzl-trade__distance').textContent=result.miles.toFixed(1)+' '+section.dataset.distance;
     result.store.parentElement.append(result.store);
    });
    show(results[0].store.querySelector('[data-location]').dataset.location);
   }catch(error){status.textContent=section.dataset.searchError;}
   finally{button.disabled=false;}
  });
 });
}
initDrzzlWholesale();
document.addEventListener('shopify:section:load',event=>initDrzzlWholesale(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
